/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Lim_ReportInputs */

const en_doc_type_lim_report = /** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LIM Report`)
};

const id_doc_type_lim_report = /** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan LIM`)
};

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const es_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const fr_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const de_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const ja_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const zh_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const ar_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const it_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const ru_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const pt_doc_type_lim_report = en_doc_type_lim_report;

/** @type {(inputs: Doc_Type_Lim_ReportInputs) => LocalizedString} */
const ko_doc_type_lim_report = en_doc_type_lim_report;

/**
* | output |
* | --- |
* | "LIM Report" |
*
* @param {Doc_Type_Lim_ReportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_lim_report = /** @type {((inputs?: Doc_Type_Lim_ReportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Lim_ReportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_lim_report(inputs)
	if (locale === "es") return es_doc_type_lim_report(inputs)
	if (locale === "fr") return fr_doc_type_lim_report(inputs)
	if (locale === "de") return de_doc_type_lim_report(inputs)
	if (locale === "ja") return ja_doc_type_lim_report(inputs)
	if (locale === "zh") return zh_doc_type_lim_report(inputs)
	if (locale === "ar") return ar_doc_type_lim_report(inputs)
	if (locale === "id") return id_doc_type_lim_report(inputs)
	if (locale === "it") return it_doc_type_lim_report(inputs)
	if (locale === "ru") return ru_doc_type_lim_report(inputs)
	if (locale === "pt") return pt_doc_type_lim_report(inputs)
	return ko_doc_type_lim_report(inputs)
});